import React from 'react';
import Button from '@components/Atoms/Button';

const BlockNavigationAway = ({
  handleNavigationCancel,
  handleNavigationConfirm,
  message,
}) => (
  <div
    className="navigation-prompt-dialog"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    }}
  >
    <div
      className="dialog-content"
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        boxShadow: '0 4px 8px rgba(74, 21, 21, 0.2)',
      }}
    >
      <h3>You&apos;re about to leave</h3>
      <p>{message}</p>
      <div
        className="dialog-actions"
        style={{
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
        }}
      >
        <Button onClick={handleNavigationCancel}>Stay on this page</Button>
        <Button onClick={handleNavigationConfirm}>Leave anyway</Button>
      </div>
    </div>
  </div>
);

export default BlockNavigationAway;
